module.exports = __webpack_public_path__ + "static/assets/f721f92d4c2e1627652824af85453a07.png";